import Resource from './base.resource'

export default class FinishesResource extends Resource
{
    constructor() {
        super('finishes')
    }
}
